import React, {useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import {makeStyles, Popover, Tab, Tabs} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import GradientGenerator from "./GradientGenerator";
import SwitchPicker from "./SwitchPicker";

const useStyles = makeStyles(() => ({
    tabRoot: {
        minWidth: 'auto'
    },
    gradientContainer: {
        width: 250,
        height: 324,
        padding: 10
    }
}))

function transformToString(objectRgba, type) {
    let resultColor = '';
    if (type === 'gradient') {
        const {colors, deg} = objectRgba;
        resultColor = `linear-gradient(${deg}, ${colors.join(', ')})`
        return resultColor
    }
    return `rgba(${objectRgba.r}, ${objectRgba.g}, ${objectRgba.b}, ${objectRgba.a})`
}

const ColorPickerPopover = (props) => {
    const {
        open, close, anchorEl, type, complete, color, disabled,
        onChange, colors, name, path, withActions = true, withGradient = true,
    } = props;
    const classes = useStyles();
    const [currentColor, setCurrentColor] = useState('');
    const [activeTab, setActiveTab] = useState("0");

    //for update tab indicator
    const actionRef = useRef(null);

    useEffect(() => {
        setTimeout(() => {
            if (actionRef.current && open) {
                actionRef.current.updateIndicator();
            }
        }, 200)
    }, [actionRef.current, open]);


    useEffect(() => {
        if (color) {
            setCurrentColor(color);
            if (typeof color === 'string' && color.includes('gradient')) {
                setTimeout(() => {
                    setActiveTab("1");
                }, 1000)
            }
        }
    }, [color])

    const onChangeColor = (color, type = 'color') => {
        if (type === 'gradient') {
            setCurrentColor(transformToString(color, type))
            return
        }
        setCurrentColor(transformToString(color.rgb, type))
    };

    function onChangeTab(v) {
        setActiveTab(v)
    }

    return (
        <Popover open={open}
                 onClose={close}
                 anchorEl={anchorEl}
                 anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
                 transformOrigin={{vertical: 'top', horizontal: 'center'}}
        >
            {withGradient && (
                <Tabs
                    action={actionRef}
                    value={activeTab}
                    onChange={(e, v) => onChangeTab(v)}
                    variant={"fullWidth"}
                    style={{minHeight: 30}}
                    indicatorColor={"primary"}
                >
                    <Tab label={"Color"} classes={{root: classes.tabRoot}} value={"0"}
                         style={{minHeight: 30, padding: 0}}/>
                    <Tab label={"Gradient"} classes={{root: classes.tabRoot}} value={"1"}
                         style={{minHeight: 30, padding: 0}}/>
                </Tabs>
            )}
            {activeTab === "0" ? (
                <SwitchPicker
                    type={type}
                    color={withActions ? currentColor : color}
                    colors={colors}
                    onChange={withActions ? onChangeColor : onChange}
                    path={path}
                    name={name}
                />
            ) : (
                <div className={classes.gradientContainer}>
                    <GradientGenerator
                        color={currentColor || color}
                        onChange={withActions ? onChangeColor : onChange}
                    />
                </div>
            )}

            {withActions && (
                <PopoverActions
                    close={close}
                    complete={complete}
                    currentColor={currentColor}
                    path={path}
                    name={name}
                />
            )}
        </Popover>
    )
}

ColorPickerPopover.propTypes = {
    //for popover
    open: PropTypes.bool.isRequired,
    close: PropTypes.func.isRequired,
    anchorEl: PropTypes.any,
    complete: PropTypes.func.isRequired,
    withActions: PropTypes.bool,

    //for pickers
    color: PropTypes.any,
    colors: PropTypes.array,
    name: PropTypes.string,
    path: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    onChange: PropTypes.func,
    type: PropTypes.oneOf(['sketch', 'chrome', 'block']),
};

export default ColorPickerPopover;

const PopoverActions = ({complete, close, currentColor, name, path}) => {
    return (
        <div style={{display: 'flex', justifyContent: 'flex-end', margin: '5px 0'}}>
            <Button
                onClick={() => {
                    complete(currentColor, name, path);
                    close()
                }}
                variant={"contained"}
                color={"primary"}
                size={"small"}
                style={{marginRight: 5}}
            >
                Apply
            </Button>
            <Button onClick={close} variant={"contained"} color={"default"} size={"small"}>Cancel</Button>
        </div>
    )
};